'use client';

import { UpmProductDetailTemplate } from 'ui-components';
import { UpmProductDetailPageProps } from './types';
import { useUpmProductDetailPage } from './useUpmProductDetailPage';

export const UpmProductDetailPage = ({
  microcopy,
  ...initialData
}: UpmProductDetailPageProps) => {
  const { data, actions } = useUpmProductDetailPage(initialData);

  return (
    <UpmProductDetailTemplate {...data} microcopy={microcopy} {...actions} />
  );
};
